const images = '/Images';
export default images;
